import React, { useState, useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { SidebarProvider } from './Components/SidebarContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loginform from './Components/Login';
import Dashboard from './Components/Dashboard';
import TransactionForm from './Components/TransactionForm';
import TransactionSearch from './Components/TransactionSearch';
import Addattribute from './Components/Addattribute';
import AttributeReport from './Components/AttributeReport';
import WorkerDashboard from './Components/WorkerDashboard';
import CreateUser from './Components/CreateUser';
import CompanySignup from './Components/CompanySignup';
import CompanySummary from './Components/CompanySummary';
import AdminDetails from './Components/AdminDetails';
import ChangePasswordForm from './Components/ChangePassword';
import SeeUserTransaction from './Components/SeeUserTransaction';
import WorkerTransactionReport from './Components/WorkerTransactionReport';
import DetailedTransactionReport from './Components/DetailedTransactionReport';
import UserReport from './Components/UserReport';
import WorkerRequestReport from './Components/WorkerRequestReport';
import SpecificWorkerReport from './Components/SpecificWorkerReport';
import WorkerNotification from './Components/WorkerNotifications';
import StatusRequestsPage from './Components/StatusRequestsPage';
import ReturnRequestManagement from './Components/ReturnRequestManagement';
import AdminReturnRequestReport from './Components/AdminReturnRequestReport';
import ReturnRequestReport from './Components/ReturnRequestReport';
import CompanyEditTransactionDashboard from './Components/CompanyEditTransactionDashboard';
import TransactionHistoryReport from './Components/TransactionHistoryReport';
import SiteManager from './Components/SiteManager';
import TransactionFullyHistoryReport from './Components/TransactionfullyHistoryReport';
import MyTransactionsReport from './Components/MyTransactionsReport';
import AdminFundRequest from './Components/AdminFundRequest';
import AdminRequestReport from './Components/AdminRequestReport';
import CompanyOwnerReturnReport from './Components/CompanyOwnerReturnReport';
import AdminReturnRequestManagement from './Components/AdminReturnRequestManagement';
import SuperAdminDashboard from './Components/SuperAdminDashboard';
import LedgerIntelligenceReport from './Components/LedgerIntelligenceReport';
import ThresholdManagement from './Components/ThresholdManagement';
import TransactionPhotoSettings from './Components/TransactionPhotoSettings';
import CompanyOwnerChatbox from './Components/CompanyOwnerChatbox';
import UserManual from './Components/UserManual';
import Projects from './Components/Projects';
import CompanyPlanProfile from './Components/CompanyPlanProfile';
import FundRequestHistoryReport from './Components/FundRequestHistoryReport';
import { applyCompanyTheme } from './utils/companyTheme';

const ProtectedRoute = ({ isAuthenticated, children }) => {
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return children;
};

function App() {
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(() => !!localStorage.getItem('id'));
  const [role, setRole] = useState(() => localStorage.getItem('role') || '');

  const refreshAuthState = () => {
    const userId = localStorage.getItem('id');
    const storedRole = localStorage.getItem('role') || '';
    setIsAuthenticated(!!userId);
    setRole(storedRole);
  };

  useEffect(() => {
    applyCompanyTheme();
    refreshAuthState();
  }, [location.pathname]);

  const isSuperAdminRoute = location.pathname.toLowerCase().startsWith('/superadmin');

  return (
    <SidebarProvider>
      {/* Removed bg-white and min-h-screen background */}
      <div className="flex flex-col">
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        {isAuthenticated && role !== 'super_admin' && !isSuperAdminRoute && <WorkerNotification />}
        <div className="flex flex-1">
          <main className={`flex-1 ${isSuperAdminRoute ? 'p-0' : ''}`}>
            <Routes>
              <Route path="/" element={<Loginform onLogin={refreshAuthState} />} />
              <Route path="/signup" element={<CompanySignup />} />
              <Route path="/usermanual" element={<UserManual />} />
              <Route path="/dashboard" element={<ProtectedRoute isAuthenticated={isAuthenticated}><Dashboard /></ProtectedRoute>} />
              <Route path="/workerdashboard" element={<ProtectedRoute isAuthenticated={isAuthenticated}><WorkerDashboard /></ProtectedRoute>} />
              <Route path="/transaction-form" element={<ProtectedRoute isAuthenticated={isAuthenticated}><TransactionForm /></ProtectedRoute>} />
              <Route path="/transaction-report" element={<ProtectedRoute isAuthenticated={isAuthenticated}><WorkerTransactionReport /></ProtectedRoute>} />
              <Route path="/my-transactions" element={<ProtectedRoute isAuthenticated={isAuthenticated}><MyTransactionsReport /></ProtectedRoute>} />
              <Route path="/transaction_Search" element={<ProtectedRoute isAuthenticated={isAuthenticated}><TransactionSearch /></ProtectedRoute>} />
              <Route path="/addattribute" element={<ProtectedRoute isAuthenticated={isAuthenticated}><Addattribute /></ProtectedRoute>} />
              <Route path="/attributeReport" element={<ProtectedRoute isAuthenticated={isAuthenticated}><AttributeReport /></ProtectedRoute>} />
              <Route path="/projects" element={<ProtectedRoute isAuthenticated={isAuthenticated}><Projects /></ProtectedRoute>} />
              <Route path="/createuser" element={<ProtectedRoute isAuthenticated={isAuthenticated}><CreateUser /></ProtectedRoute>} />
              <Route path="/company-summary" element={<ProtectedRoute isAuthenticated={isAuthenticated}><CompanySummary /></ProtectedRoute>} />
              <Route path="/admin-details" element={<ProtectedRoute isAuthenticated={isAuthenticated}><AdminDetails /></ProtectedRoute>} />
              <Route path="/changepassword" element={<ProtectedRoute isAuthenticated={isAuthenticated}><ChangePasswordForm /></ProtectedRoute>} />
              <Route path="/usertransaction" element={<ProtectedRoute isAuthenticated={isAuthenticated}><SeeUserTransaction entityRole="worker" /></ProtectedRoute>} />
              <Route path="/admin-transaction-details" element={<ProtectedRoute isAuthenticated={isAuthenticated}><SeeUserTransaction entityRole="admin" /></ProtectedRoute>} />
              <Route path="/detailedreport" element={<ProtectedRoute isAuthenticated={isAuthenticated}><DetailedTransactionReport /></ProtectedRoute>} />
              <Route path="/UserReport" element={<ProtectedRoute isAuthenticated={isAuthenticated}><UserReport /></ProtectedRoute>} />
              <Route path="/RequestReport" element={<ProtectedRoute isAuthenticated={isAuthenticated}><WorkerRequestReport /></ProtectedRoute>} />
              <Route path="/SpecificWorkerReport" element={<ProtectedRoute isAuthenticated={isAuthenticated}><SpecificWorkerReport /></ProtectedRoute>} />
              <Route path="/StatusRequests" element={<ProtectedRoute isAuthenticated={isAuthenticated}><StatusRequestsPage/></ProtectedRoute>} /> 
              <Route path="/Return" element={<ProtectedRoute isAuthenticated={isAuthenticated}><ReturnRequestManagement/></ProtectedRoute>} />
              <Route
                path="/AdminReturn"
                element={
                  <ProtectedRoute isAuthenticated={isAuthenticated}>
                    <AdminReturnRequestReport />
                  </ProtectedRoute>
                }
              />  
              <Route path="/Edit" element={<ProtectedRoute isAuthenticated={isAuthenticated}><CompanyEditTransactionDashboard/></ProtectedRoute>} />
              <Route path="/edit" element={<ProtectedRoute isAuthenticated={isAuthenticated}><CompanyEditTransactionDashboard/></ProtectedRoute>} />
              <Route path="/TransactionHistory" element={<ProtectedRoute isAuthenticated={isAuthenticated}><TransactionHistoryReport/></ProtectedRoute>} /> 
              <Route path="/AddSite" element={<ProtectedRoute isAuthenticated={isAuthenticated}><SiteManager/></ProtectedRoute>} /> 
              <Route path="/TransactionHistoryReport" element={<ProtectedRoute isAuthenticated={isAuthenticated}><TransactionFullyHistoryReport/></ProtectedRoute>} />
              <Route path="/ReportReturn" element={<ProtectedRoute isAuthenticated={isAuthenticated}><ReturnRequestReport/></ProtectedRoute>} />
              <Route path="/admin-fund-request" element={<ProtectedRoute isAuthenticated={isAuthenticated}><AdminFundRequest /></ProtectedRoute>} />
              <Route path="/admin-request-report" element={<ProtectedRoute isAuthenticated={isAuthenticated}><AdminRequestReport/></ProtectedRoute>} />
              <Route path="/admin-request-history" element={<ProtectedRoute isAuthenticated={isAuthenticated}><FundRequestHistoryReport type="admin" /></ProtectedRoute>} />
              <Route path="/worker-request-history" element={<ProtectedRoute isAuthenticated={isAuthenticated}><FundRequestHistoryReport type="worker" /></ProtectedRoute>} />
              <Route path="/admin-return" element={<ProtectedRoute isAuthenticated={isAuthenticated}><AdminReturnRequestManagement/></ProtectedRoute>} />
              <Route path="/company-owner-returns" element={<ProtectedRoute isAuthenticated={isAuthenticated}><CompanyOwnerReturnReport/></ProtectedRoute>} />
              <Route path="/ledger-reports" element={<ProtectedRoute isAuthenticated={isAuthenticated}><LedgerIntelligenceReport /></ProtectedRoute>} />
              <Route path="/threshold-management" element={<ProtectedRoute isAuthenticated={isAuthenticated}><ThresholdManagement/></ProtectedRoute>} />
              <Route path="/transaction-photo-settings" element={<ProtectedRoute isAuthenticated={isAuthenticated}><TransactionPhotoSettings/></ProtectedRoute>} />
              <Route path="/company-plan-profile" element={<ProtectedRoute isAuthenticated={isAuthenticated}><CompanyPlanProfile/></ProtectedRoute>} />
              <Route path="/superadmin/*" element={<ProtectedRoute isAuthenticated={isAuthenticated}><SuperAdminDashboard/></ProtectedRoute>} />
            </Routes> 
          </main>
        </div>
        {isAuthenticated && role === 'company_owner' && !isSuperAdminRoute && <CompanyOwnerChatbox />}
      </div>
    </SidebarProvider>
  );
}

export default App;
